module.exports = __webpack_public_path__ + "img/polar.b1a6a501.svg";